// extracted by mini-css-extract-plugin
export default {"slice":"Slice_slice__l98fa"};